// removed by extract-text-webpack-plugin
module.exports = {"authorizationButton":"_23UhVDHy5dkBFbXfQXMSw2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AuthorizationButton/AuthorizationButton.scss
// module id = 1569
// module chunks = 0